/* eslint-disable */
import session from './session';

export default {
    getModelList(filter) {
        return session.get(`device_model/${filter}`);
    },
    getModel(id) {
        return session.get(`device_model/${id}/`);
    },
    createModel(data) {
        return session.post(`device_model/`, data);
    },
    updateModel(id, data) {
        return session.patch(`device_model/${id}/`, data);
    },
    deleteModel(id) {
        return session.delete(`device_model/${id}/`);
    },
};